import React, { useMemo } from 'react';
import { LinkButton } from '../button/Button';
import { useCurrentLocale } from '../../../../../locales/useTranslator';
import { LOGIN_PAGE_URL } from '../../../../../util/urlConstants';
import { getPrismicLocale, Locale } from '../../../../../locales/localeTypes';
export var LoginLinkButton = function LoginLinkButton(_ref) {
  var children = _ref.children;
  var locale = useCurrentLocale();
  var loginLink = useMemo(function () {
    if (locale === Locale.English) return LOGIN_PAGE_URL;
    var appLocale = getPrismicLocale(locale);
    return "".concat(LOGIN_PAGE_URL, "?appLocale=").concat(appLocale);
  }, [locale]);
  return /*#__PURE__*/React.createElement(LinkButton, {
    href: loginLink
  }, children);
};